import React from "react";
import ReactApexChart from "react-apexcharts";

const AreaExpenseChart = () => {
  const series = [
    {
      name: "STOCK ABC",
      data: [1000, 1500, 200, 2400, 1400, 100, 1700],
    },
  ];

  const options = {
    chart: {
      type: "area",
      height: 350,
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      fontFamily: "Pio Medium",
    },
    colors: ["#ef4444"], // Red color for area line and fill
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    title: {
      text: "Expense Summary",
      align: "left",
      style: {
        fontSize: "18px",
        fontWeight: "500",
        color: "#000000",
      },
    },
    labels: ["Jan", "Feb", "March", "April", "May", "June", "July"],
    xaxis: {
      type: "category",
      labels: {
        style: {
          fontSize: "12px",
          fontWeight: 500,
          colors: "#000000", // Red x-axis labels
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: "#000000", // Red y-axis labels
          fontSize: "12px",
        },
      },
    },
    legend: {
      horizontalAlign: "left",
      labels: {
        colors: "#ef4444", // Optional: make legend labels red
      },
    },
    grid: {
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
  };

  return (
    <div>
      <div id="chart" style={{ fontFamily: "text-medium" }}>
        <ReactApexChart
          options={options}
          series={series}
          type="area"
          height={350}
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default AreaExpenseChart;
